import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-upgrade-redirection',
  templateUrl: './upgrade-redirection.component.html',
  styleUrls: ['./upgrade-redirection.component.scss']
})
export class UpgradeRedirectionComponent {
   ngOnInit(): void {
      window.location.href = `${environment.cphost}/account/upgrade`;
    }
}
